var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":true,"width":"350"}},[_c('v-card',[_c('v-card-text',[_c('ContactListEditor',{on:{"input":_vm.l},model:{value:(_vm.contacts),callback:function ($$v) {_vm.contacts=$$v},expression:"contacts"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }